import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { MobileNoteEditorComponent } from '../components/batch-note-editor/mobile-note-editor.component';

@Injectable({ providedIn: 'root' })
export class MobileNoteDeactivateGuard implements CanDeactivate<MobileNoteEditorComponent> {
  canDeactivate(component: MobileNoteEditorComponent): Observable<boolean> | boolean {
    return component.confirmNavigationIfNeeded();
  }
}
